import authService from '@/api/authService'

const background = require('@/assets/bg/fondo_login.png')

export default {
  name: 'Login',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      username: null,
      password: null,
      loading: false,
      error: null
    }
  },
  computed: {
    clientBackgroundStyle () {
      return { 'background-image': `url(${background})` }
    }
  },
  methods: {
    async login () {
      this.loading = true
      this.error = null
      try {
        await authService.login({
          username: this.username,
          password: this.password
        })
        this.$router.push('/')
      } catch (err) {
        // eslint-disable-next-line
        console.error('[login.js] Error logging in', err)
        this.error = 'Usuario o contraseña incorrectos'
      }
      this.loading = false
    }
  }
}
